import type { InputHTMLAttributes } from 'react';
import { cn } from '@/shared/lib/cn';
import {
  focusRingClassNameStrong,
  formControlSurfaceClassName,
  formInputClassName,
} from '@/shared/config/theme';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean;
}

export default function Input({ className, hasError = false, ...props }: InputProps) {
  return (
    <input
      className={cn(
        'w-full rounded-lg border border-gray-300 px-3 text-sm placeholder:text-gray-400',
        formInputClassName,
        formControlSurfaceClassName,
        focusRingClassNameStrong,
        hasError && 'border-red-500 focus:ring-red-500',
        className,
      )}
      {...props}
    />
  );
}
